import mdAxios from 'core/common/config/axios-config';
import {PriceComponent, Vehicle, Price, PRICECOMPLEVEL, Product, ProductVehicle} from "product/productDomain";
import {observable} from "mobx";
import {AxiosResponse} from "axios";
import {DataObjectDto, IDomainObject} from "core/form/formUtils";
import {PVADObjectDto} from "product/component/productVehicleAssignDialog";


class ProductService  {



  @observable public priceComponentObject: PriceComponent;
  @observable public vehicleObject: Vehicle;
  @observable public productObject: Product;


// ////////// VEHICLE ////////////////////////////////////////////////////////////////////////////////

  readVehicle(vehicleId: number, allPrices?: boolean): Promise<Vehicle> {
    return mdAxios.get('/vehicle/' + vehicleId, {params: {allPrices}})
      .then(response => new Vehicle(response.data));
  }


  readProductVehiclePrice(productId, vehicleId, partyId, currency): Promise<Price> {
    return mdAxios.get('/product/product-vehicle-price/' + productId + '/' + vehicleId + '/' + partyId, {params: {currency}})
      .then(response => response.data);
  }


  /**
   * spec :  {registrationNumber: 456456}, {vin: 346456456}
   * @param spec
   * @returns {*}
   */
  vehicleExist(spec): Promise<boolean> {
    return mdAxios.get('/vehicle/vehicle-exist', {params:spec})
      .then(response => response.data);
  }


  vehicleSave(vehicleDto: DataObjectDto<Vehicle>): Promise<IDomainObject> {
    return mdAxios.post('/vehicle', vehicleDto, {showPrettyError: true})
      .then((response) => response.data);
  }

  deleteVehicle(vehicleId: number) {
    return mdAxios.delete('/vehicle/' + vehicleId, {showPrettyError: true});
  }


// ////////// PRODUCT ////////////////////////////////////////////////////////////////////////////////


  assignProducts(PVADObject: PVADObjectDto, part: number) : Promise<PVADObjectDto> {
    return mdAxios.post('/vehicle/assign-products/' + part, PVADObject, {showPrettyError: true})
      .then((response) => new PVADObjectDto(response.data));
  }


  readProduct(productId: number, billedFrom?: number, billedTo?: number): Promise<Product> {
    return mdAxios.get('/product/' + productId, {params: {billedFrom, billedTo}})
      .then(response => { console.log(response); return new Product(response.data)});
  }

  readProductPrice(productId: number, partyId: number, currency: string): Promise<Price> {
    return mdAxios.get('/product/product-price/' + productId + '/' + partyId, {params: {currency}})
      .then(response => response.data);
  }


  productSave(product: Product): Promise<IDomainObject> {
    return mdAxios.post('/product', product)
      .then((response) => response.data);
  }

  deleteProduct(productId: number) {
    return mdAxios.delete('/product/' + productId, {showPrettyError: true});
  }

  isProductNumberUnique(productNumber : string): Promise<boolean> {
    return mdAxios.get('/product/product-number-exist', {params: {productNumber}})
      .then(response => response.data);
  }


  // ////////// PRICECOMPOMENT ////////////////////////////////////////////////////////////////////////////////

  readPriceComponent(priceComponentId) : Promise<PriceComponent> {
    return mdAxios.get('/price-component/' + priceComponentId)
      .then(response => new PriceComponent(response.data));
  }

  searchPriceComponents(productId: number, vehicleId: number, partyId: number, priceLevel: PRICECOMPLEVEL): Promise<PriceComponent[]> {
    return mdAxios.get('/price-component', {params:{productId, vehicleId, partyId, priceLevel}})
      .then(response => response.data.map(v => new PriceComponent(v)));
  }

  initPriceComponent(partyId) : Promise<PriceComponent> {
    return mdAxios.get('/price-component/init-new', {params:{partyId}})
      .then(response => new PriceComponent(response.data));
  }

  priceComponentSave(priceComponent: PriceComponent) : Promise<IDomainObject> {
    return mdAxios.post('/price-component', priceComponent, {showPrettyError: true})
      .then((response) => response.data);
  }

  deletePriceComponent(priceComponentId: number) : Promise<AxiosResponse> {
    return mdAxios.delete('/price-component/' + priceComponentId, {showPrettyError: true});
  }

}

  

const productService = new ProductService();
export default productService;




// WEBPACK FOOTER //
// ./src/product/productService.ts